var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close modal-close",class:{ disabled: _vm.disabled },on:{"click":_vm.closeModal}},[_c('span',[_vm._v("×")])])
}
var staticRenderFns = []

export { render, staticRenderFns }